import { BusinessLabel, DownloadParamsType, GetMessageType, ModelType } from "@whatslly/types/instant-messaging/WhatsappTypes";
import { WhatsappSelectorsType } from "@whatslly/types/integrations/im/WhatsappGetSelectorsResponse";
import { SelectedContactType } from "@whatslly/types/SelectedContactType";
import { ContactFilterObjectType, RefreshStrategyType } from "@whatslly/types/ContactFilterObject";
import type { RawGroupEventType } from "@whatslly/types/integrations/schemas/group-metadata/GroupEventTypes";

export const IInstantMessagingServiceSymbol = Symbol.for("InstantMessagingService");

export interface InstantMessagingService {
  findAndSaveWapJsApi?(): Promise<void>;

  isDownloadValid?(params: Omit<DownloadParamsType, "signal">): boolean;

  downloadAndDecrypt?(params: DownloadParamsType): Promise<any>;

  getSearchName?(saved?: string, origin?: string): string;

  preloadContactImg?(): Promise<string | undefined>;

  hasGroupElement?(selectors: WhatsappSelectorsType): boolean;

  forceRerender?(): void;

  getModelId?(model: ModelType | undefined): string | undefined;

  updateModelAppear?(model: ModelType, state: boolean): void;

  getAllModels?(): ModelType[];

  unreadCounters?(): { chats: number; messages: number };

  getChatActiveModal?(): ModelType | undefined;

  getSelectedContact(): SelectedContactType | undefined;

  getMe(): { id?: string; server: string; phone: string; isBusiness?: boolean; name?: string } | undefined;

  queryAllGroups?(): Promise<any>;

  queryAllGroupEvents?(groupIds?: string[], lastSyncTimestamps?: Record<string, number>): Promise<RawGroupEventType[]>;

  getAllMessages?(): GetMessageType[];

  loadEarlierMessages?(): Promise<void>;

  closeChat?(chat: ModelType | undefined): void;

  getWapVersion(): string | undefined;

  openChat?(phone: string, forceOpenChat?: boolean, useOnlyWapSpecialLink?: boolean): Promise<void>;

  init?(selectors: WhatsappSelectorsType): void;

  supportedFilters?: Readonly<Array<keyof ContactFilterObjectType>>;
  filterContactList({
    filter,
    refreshStrategy,
    refreshOnEvent,
  }: {
    filter: ContactFilterObjectType;
    refreshStrategy?: RefreshStrategyType;
    refreshOnEvent: boolean;
  }): void;
  getFilteredChatIds(): string[] | undefined;
  countFilteredChats?(filter: ContactFilterObjectType): Promise<number>;
  getContactCountryCodes(): Promise<string[]>;
  getBusinessLabels?(): Promise<Array<BusinessLabel & { count: number }>>;
  getChatsLabels?(): Promise<Map<string, number>>;
  addLabel?(labelName: string): Promise<void>;
  deleteLabel?(labelId: string): Promise<boolean>;

  isBusiness?(): Promise<boolean>;

  get headerElement(): HTMLElement | null;
  get footerElement(): HTMLElement | null;

  isConnected?(): boolean;

  logout?(): void;

  hasMainElement(selectors: WhatsappSelectorsType): boolean;
}
